import { init } from '@rematch/core';
import thunk from 'redux-thunk';
import user from './models/user';
import login from './models/login';


const models = {
  user,
  login,
};

export default init({
  models,
  redux: {
    middlewares: [thunk],
    devtoolOptions: {
      disabled: process.env.NODE_ENV === 'production',
    },
  },
});
